import { makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IAccessGroup {
  [key: string]: any
}

export class AccessGroup extends Model<IAccessGroup> {
  constructor(attr: IAccessGroup = {}) {
    super(attr)
    makeObservable(this, {})
  }

  static urlRoot() {
    return '/automations/access_groups'
  }
}
